import { Paper } from "@deere/fuel-react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

export type AlertItemProps = {
  heading: string;
  message: string;
  date: string;
  isRead: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  icon?: React.ReactElement;
};

const AlertItem = ({
  heading,
  message,
  date,
  buttonText,
  isRead,
  onButtonClick,
  icon,
}: AlertItemProps) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        padding: theme.tokens.FuelSpacing4,
        marginBottom: 0.125,
        ...(!isRead && {
          borderLeft: `4px solid ${theme.tokens.FuelColorAlertWarningIcon}`,
          backgroundColor: theme.tokens.FuelColorAlertWarningBackground,
        }),
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box
          sx={{
            backgroundColor: "#FEE7C4",
            p: 1,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon ?? (
            <WarningAmberRoundedIcon
              sx={{ color: theme.tokens.FuelColorAlertWarningIcon }}
            />
          )}
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Stack spacing={0.5}>
            <Typography fontWeight={theme.tokens.FuelFontWeightBold}>
              {heading}
            </Typography>
            <Typography color={theme.tokens.FuelColorTextSecondary}>
              {message}
            </Typography>
          </Stack>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
              height: theme.tokens.FuelLineHeight3xl,
            }}
          >
            {buttonText ? (
              <Button
                variant="text"
                size="small"
                sx={{
                  color: theme.tokens.FuelColorGreen700,
                  textTransform: "none",
                }}
                onClick={onButtonClick}
              >
                {buttonText}
              </Button>
            ) : (
              <span />
            )}

            <Typography
              variant="body2"
              color={theme.tokens.FuelColorTextSecondary}
              sx={{ whiteSpace: "nowrap" }}
            >
              {date}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

export default AlertItem;
